<script>
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { onMount } from 'svelte';
import {
    fade
} from 'svelte/transition';
import * as m from "@app/paraglide/messages.js";

let progress = $state(0), statusMsg = $state(m.sync_changes_status_starting());

onMount(async () => {
    try {
        console.log(m.sync_changes_log_start());
        if (eventGroupState[projectState.selected] && eventGroupState[projectState.selected].type === "translation"){
            let linkedGroupIndex = eventGroupState.findIndex(evg =>{
                return evg.id === eventGroupState[projectState.selected].linkedGroup;
            });

            if (linkedGroupIndex === -1){
                throw new Error(m.sync_changes_missing_group_error({
                    id: eventGroupState[projectState.selected].linkedGroup,
                }));
            }

            eventGroupState[linkedGroupIndex].events.forEach((event, index, events) =>{
                progress = parseInt((index/events.length) * 100);
                statusMsg = m.sync_changes_status_progress({
                    current: index + 1,
                    total: events.length,
                });

                let eventIndex = eventGroupState[projectState.selected].events.findIndex(ev =>{
                    return ev.id === event.id;
                });

                if (eventIndex > -1){
                    eventGroupState[projectState.selected].events[eventIndex].original = event.text;
                    eventGroupState[projectState.selected].events[eventIndex].start = event.start;
                    eventGroupState[projectState.selected].events[eventIndex].end = event.end;
                    eventGroupState[projectState.selected].events[eventIndex].xPos = event.xPos;
                    eventGroupState[projectState.selected].events[eventIndex].yPos = event.yPos;
                    eventGroupState[projectState.selected].events[eventIndex].xPos = event.xPos;
                    eventGroupState[projectState.selected].events[eventIndex].yPos = event.yPos;
                    eventGroupState[projectState.selected].events[eventIndex].alignment = event.alignment;
                    eventGroupState[projectState.selected].events[eventIndex].speakers = event.speakers;
                    eventGroupState[projectState.selected].events[eventIndex].style = event.style;
                    eventGroupState[projectState.selected].events[eventIndex].forced = event.forced;
                } else {
                    if (eventGroupState[projectState.selected].events.length > index+1){
                        eventGroupState[projectState.selected].events.splice(index,0, 
                        {
                            ...(JSON.parse(JSON.stringify(event))),
                            text : "",
                            original : event.text
                        });

                        eventGroupState[projectState.selected].events = eventGroupState[projectState.selected].events;
                    } else {
                        eventGroupState[projectState.selected].events = [
                            ...eventGroupState[projectState.selected].events,
                            {
                                ...(JSON.parse(JSON.stringify(event))),
                                text : "",
                                original : event.text
                            }
                        ];
                    }                    
                }
            });
        }

        toast.push(m.sync_changes_success_toast(), {
            classes: ["toast-success"],
        });

        insertHistoryAction({
            name: "sync event group", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        hideModal();
        
    } catch(err){
        console.log(err, err.message);
        progress = 100;
        statusMsg = m.sync_changes_status_error({ error: err.message });

        toast.push(m.sync_changes_error_toast({ error: err.message }), {
            classes: ["toast-danger"],
        });

        hideModal();
    }
});
</script>

<div transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'syncChanges' ? 'show d-block' : ''}" 
    role="dialog"
    aria-labelledby="syncChangesTitle"
    aria-modal="true" 
    tabindex="-1" 
    id="SyncChanges">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="syncChangesTitle">
                    {m.sync_changes_title()}
                </h4>
            </div>
            <div class="modal-body">
                <p role="alert">
                    <i class="bi bi-exclamation-diamond-fill"></i>
                    {m.sync_changes_warning()}
                </p>
                <div class="progress" role="progressbar" aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar bg-primary progress-bar-striped progress-bar-animated" 
                        style="width: {progress}%;" 
                        aria-label={m.sync_changes_progress_label()}>
                        {progress}%
                    </div>
                </div>
                <p class="text-center text-muted small" role="status" aria-live="polite">{statusMsg}</p>
            </div>
        </div>
    </div>
</div>
